module.exports = __webpack_public_path__ + "static/media/video (1).2c8a532c.mp4";